import {AbstractControl} from '@angular/forms';
import {Injector} from '@angular/core';
import {EffektService} from '../services/aftale-helper.service';
import {ProduktEnum} from "src/app/api/models/OK/Egis/Service/Models/Entities/Enums/produkt-enum";

export function effektValidator(formControl: AbstractControl) {
  let injector = Injector.create([{ provide: EffektService, useClass: EffektService, deps: [] }]);
  let effektService = injector.get(EffektService);

  if (!formControl.parent) {
    return null;
  }

  if (!formControl.parent.get('effekt') || !formControl.parent.get('produktId')) {
    return null;
  }

  const effektStr = formControl.parent.get('effekt').value;
  const produktId: ProduktEnum = formControl.parent.get('produktId').value;

  const effekt = effektService.getEffekt(effektStr);

  if (effekt.minEffekt && effekt.minEffekt && produktId == ProduktEnum.Varmepumpe) {
    return { produkt: { value: '' } };
  }

  if (effekt.minEffekt > effekt.maxEffekt) {
    return { minmax: { value: '' } };
  }

  return null;
}
